module.exports = __webpack_public_path__ + "media/images/pwa/safari_plus-c6d38281d140553d1c06e97f1d6ff02f.png";